import React, { useMemo, useState } from 'react'
import { HeaderShowContext } from 'components/Header/HeaderShow/context'

export const HeaderShowProvider = ({
  children,
  headerExists = true
}: {
  headerExists?: boolean
  children: React.ReactElement
}) => {
  const [show, setShow] = useState<boolean>(headerExists)
  const value = useMemo(
    () => ({ show, setShow, headerExists }),
    [show, setShow, headerExists]
  )
  return (
    <HeaderShowContext.Provider value={value}>
      {children}
    </HeaderShowContext.Provider>
  )
}
